import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "cambio-error",
  templateUrl: "./cambio-error.component.html",
  styleUrls: ["./cambio-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class CambioErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsExchange: string[] = [
    "accountManagerName",
    "accountManagerDocument",
    "portfolioDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioName",
    "portfolioCode",
    "ticketCuttofTypeId",
    "operationTypeId",
    "currencyQuotation",
    "parityPl",
    "parityMtm",
    "settlementDate",
    "counterpartName",
    "tradingPlace",
    "settlementPlace",
    "appealDate",
    "expirationDate",
    "contractSaleSettlementDate",
    "currencyAmount",
    "annotations",
  ];

  ngOnInit(): void {}
}
